export const LINK_PHONE_GET_CODE_REQUEST = 'LINK_PHONE_GET_CODE_REQUEST';
export const LINK_PHONE_GET_CODE_SUCCESS = 'LINK_PHONE_GET_CODE_SUCCESS';
export const LINK_PHONE_GET_CODE_FAILURE = 'LINK_PHONE_GET_CODE_FAILURE';
export const LINK_PHONE_VERIFY_CODE_REQUEST = 'LINK_PHONE_VERIFY_CODE_REQUEST';
export const LINK_PHONE_VERIFY_CODE_SUCCESS = 'LINK_PHONE_VERIFY_CODE_SUCCESS';
export const LINK_PHONE_VERIFY_CODE_FAILURE = 'LINK_PHONE_VERIFY_CODE_FAILURE';
export const CACHE_TRADING_ACCOUNT = 'CACHE_TRADING_ACCOUNT';
export const GET_CONNECTED_ACCOUNT_REQUEST = 'GET_CONNECTED_ACCOUNT_REQUEST';
export const GET_CONNECTED_ACCOUNT_SUCCESS = 'GET_CONNECTED_ACCOUNT_SUCCESS';
export const GET_CONNECTED_ACCOUNT_FAILURE = 'GET_CONNECTED_ACCOUNT_FAILURE';
export const GET_STOCK_REQUEST = 'GET_STOCK_REQUEST';
export const GET_STOCK_SUCCESS = 'GET_STOCK_SUCCESS';
export const GET_STOCK_FAILURE = 'GET_STOCK_FAILURE';
export const GET_STOCK_META_REQUEST = 'GET_STOCK_META_REQUEST';
export const GET_STOCK_META_SUCCESS = 'GET_STOCK_META_SUCCESS';
export const GET_STOCK_META_FAILURE = 'GET_STOCK_META_FAILURE';
export const GET_DIRECT_DEBIT_ESTIMATED_DATE_REQUEST = 'GET_DIRECT_DEBIT_ESTIMATED_DATE_REQUEST';
export const GET_DIRECT_DEBIT_ESTIMATED_DATE_SUCCESS = 'GET_DIRECT_DEBIT_ESTIMATED_DATE_SUCCESS';
export const GET_DIRECT_DEBIT_ESTIMATED_DATE_FAILURE = 'GET_DIRECT_DEBIT_ESTIMATED_DATE_FAILURE';
export const GET_ACTIVITIES_REQUEST = 'GET_ACTIVITIES_REQUEST';
export const GET_ACTIVITIES_SUCCESS = 'GET_ACTIVITIES_SUCCESS';
export const GET_ACTIVITIES_FAILURE = 'GET_ACTIVITIES_FAILURE';
export const GET_ORDERS_REQUEST = 'GET_ORDERS_REQUEST';
export const GET_ORDERS_SUCCESS = 'GET_ORDERS_SUCCESS';
export const GET_ORDERS_FAILURE = 'GET_ORDERS_FAILURE';
export const GET_ORDER_REQUEST = 'GET_ORDER_REQUEST';
export const GET_ORDER_SUCCESS = 'GET_ORDER_SUCCESS';
export const GET_ORDER_FAILURE = 'GET_ORDER_FAILURE';
export const GET_POSITIONS_REQUEST = 'GET_POSITIONS_REQUEST';
export const GET_POSITIONS_SUCCESS = 'GET_POSITIONS_SUCCESS';
export const GET_POSITIONS_FAILURE = 'GET_POSITIONS_FAILURE';
export const GET_TRUSTED_CONTACTS_REQUEST = 'GET_TRUSTED_CONTACTS_REQUEST';
export const GET_TRUSTED_CONTACTS_SUCCESS = 'GET_TRUSTED_CONTACTS_SUCCESS';
export const GET_TRUSTED_CONTACTS_FAILURE = 'GET_TRUSTED_CONTACTS_FAILURE';
export const ADD_TRUSTED_CONTACT_REQUEST = 'ADD_TRUSTED_CONTACT_REQUEST';
export const ADD_TRUSTED_CONTACT_SUCCESS = 'ADD_TRUSTED_CONTACT_SUCCESS';
export const ADD_TRUSTED_CONTACT_FAILURE = 'ADD_TRUSTED_CONTACT_FAILURE';
export const EDIT_TRUSTED_CONTACT_REQUEST = 'EDIT_TRUSTED_CONTACT_REQUEST';
export const EDIT_TRUSTED_CONTACT_SUCCESS = 'EDIT_TRUSTED_CONTACT_SUCCESS';
export const EDIT_TRUSTED_CONTACT_FAILURE = 'EDIT_TRUSTED_CONTACT_FAILURE';
export const CREATE_TRADING_ACCOUNT_REQUEST = 'CREATE_TRADING_ACCOUNT_REQUEST';
export const CREATE_TRADING_ACCOUNT_SUCCESS = 'CREATE_TRADING_ACCOUNT_SUCCESS';
export const CREATE_TRADING_ACCOUNT_FAILURE = 'CREATE_TRADING_ACCOUNT_FAILURE';
export const CREATE_ORDER_SUCCESS = 'CREATE_ORDER_SUCCESS';
export const CANCEL_ORDER_SUCCESS = 'CANCEL_ORDER_SUCCESS';
export const GET_SEARCH_RESULTS_SUCCESS = 'GET_SEARCH_RESULTS_SUCCESS';
export const CACHE_CURRENT_STOCK_PRICE = 'CACHE_CURRENT_STOCK_PRICE';
export const SET_ACCOUNT_STATUS = 'SET_ACCOUNT_STATUS';
export const CLEAR_FIRST_ACCOUNT_ACTIVATED_FLAG = 'CLEAR_FIRST_ACCOUNT_ACTIVATED_FLAG';
export const GET_REAL_TIME_PRICES_SUCCESS = 'GET_REAL_TIME_PRICES_SUCCESS';
export const GET_REAL_TIME_PRICES_FAILURE = 'GET_REAL_TIME_PRICES_FAILURE';
export const UPDATE_WEALTH_ACCOUNTS = 'UPDATE_WEALTH_ACCOUNTS';
export const SET_ASSET_ID_TO_FETCH_REAL_TIME_PRICES = 'SET_ASSET_ID_TO_FETCH_REAL_TIME_PRICES';
export const REMOVE_ASSET_ID_TO_FETCH_REAL_TIME_PRICES = 'REMOVE_ASSET_ID_TO_FETCH_REAL_TIME_PRICES';
export const GET_TRANSFER_PROVIDERS_REQUEST = 'GET_TRANSFER_PROVIDERS_REQUEST';
export const GET_TRANSFER_PROVIDERS_SUCCESS = 'GET_TRANSFER_PROVIDERS_SUCCESS';
export const GET_TRANSFER_PROVIDERS_FAILURE = 'GET_TRANSFER_PROVIDERS_FAILURE';
export const CREATE_PRODUCT_TRANSFER_REQUEST = 'CREATE_PRODUCT_TRANSFER_REQUEST';
export const CREATE_PRODUCT_TRANSFER_SUCCESS = 'CREATE_PRODUCT_TRANSFER_SUCCESS';
export const CREATE_PRODUCT_TRANSFER_FAILURE = 'CREATE_PRODUCT_TRANSFER_FAILURE';
export const GET_PRODUCT_TRANSFER_REQUEST = 'GET_PRODUCT_TRANSFER_REQUEST';
export const GET_PRODUCT_TRANSFER_SUCCESS = 'GET_PRODUCT_TRANSFER_SUCCESS';
export const GET_PRODUCT_TRANSFER_FAILURE = 'GET_PRODUCT_TRANSFER_FAILURE';
export const GET_AUTOINVEST_REQUEST = 'GET_AUTOINVEST_REQUEST';
export const GET_AUTOINVEST_SUCCESS = 'GET_AUTOINVEST_SUCCESS';
export const GET_AUTOINVEST_FAILURE = 'GET_AUTOINVEST_FAILURE';
export const CREATE_AUTOINVEST_PLAN_REQUEST = 'CREATE_AUTOINVEST_PLAN_REQUEST';
export const CREATE_AUTOINVEST_PLAN_SUCCESS = 'CREATE_AUTOINVEST_PLAN_SUCCESS';
export const CREATE_AUTOINVEST_PLAN_FAILURE = 'CREATE_AUTOINVEST_PLAN_FAILURE';
export const EDIT_AUTOINVEST_PLAN_REQUEST = 'EDIT_AUTOINVEST_PLAN_REQUEST';
export const EDIT_AUTOINVEST_PLAN_SUCCESS = 'EDIT_AUTOINVEST_PLAN_SUCCESS';
export const EDIT_AUTOINVEST_PLAN_FAILURE = 'EDIT_AUTOINVEST_PLAN_FAILURE';
export const PAUSE_AUTOINVEST_PLAN_REQUEST = 'PAUSE_AUTOINVEST_PLAN_REQUEST';
export const PAUSE_AUTOINVEST_PLAN_SUCCESS = 'PAUSE_AUTOINVEST_PLAN_SUCCESS';
export const PAUSE_AUTOINVEST_PLAN_FAILURE = 'PAUSE_AUTOINVEST_PLAN_FAILURE';
export const RESUME_AUTOINVEST_PLAN_REQUEST = 'RESUME_AUTOINVEST_PLAN_REQUEST';
export const RESUME_AUTOINVEST_PLAN_SUCCESS = 'RESUME_AUTOINVEST_PLAN_SUCCESS';
export const RESUME_AUTOINVEST_PLAN_FAILURE = 'RESUME_AUTOINVEST_PLAN_FAILURE';
export const CANCEL_AUTOINVEST_PLAN_REQUEST = 'CANCEL_AUTOINVEST_PLAN_REQUEST';
export const CANCEL_AUTOINVEST_PLAN_SUCCESS = 'CANCEL_AUTOINVEST_PLAN_SUCCESS';
export const CANCEL_AUTOINVEST_PLAN_FAILURE = 'CANCEL_AUTOINVEST_PLAN_FAILURE';
export const SKIP_AUTOINVEST_PAYMENT_REQUEST = 'SKIP_AUTOINVEST_PAYMENT_REQUEST';
export const SKIP_AUTOINVEST_PAYMENT_SUCCESS = 'SKIP_AUTOINVEST_PAYMENT_SUCCESS';
export const SKIP_AUTOINVEST_PAYMENT_FAILURE = 'SKIP_AUTOINVEST_PAYMENT_FAILURE';
export const UNSKIP_AUTOINVEST_PAYMENT_REQUEST = 'UNSKIP_AUTOINVEST_PAYMENT_REQUEST';
export const UNSKIP_AUTOINVEST_PAYMENT_SUCCESS = 'UNSKIP_AUTOINVEST_PAYMENT_SUCCESS';
export const UNSKIP_AUTOINVEST_PAYMENT_FAILURE = 'UNSKIP_AUTOINVEST_PAYMENT_FAILURE';
export const ACCEPT_AUTOINVEST_MANDATE_REQUEST = 'ACCEPT_AUTOINVEST_MANDATE_REQUEST';
export const ACCEPT_AUTOINVEST_MANDATE_SUCCESS = 'ACCEPT_AUTOINVEST_MANDATE_SUCCESS';
export const ACCEPT_AUTOINVEST_MANDATE_FAILURE = 'ACCEPT_AUTOINVEST_MANDATE_FAILURE';
export const GET_AUTOINVEST_ACTIVITY_REQUEST = 'GET_AUTOINVEST_ACTIVITY_REQUEST';
export const GET_AUTOINVEST_ACTIVITY_SUCCESS = 'GET_AUTOINVEST_ACTIVITY_SUCCESS';
export const GET_AUTOINVEST_ACTIVITY_FAILURE = 'GET_AUTOINVEST_ACTIVITY_FAILURE';
export const EDIT_JISA_CHILD_ADDRESS_REQUEST = 'EDIT_JISA_CHILD_ADDRESS_REQUEST';
export const EDIT_JISA_CHILD_ADDRESS_SUCCESS = 'EDIT_JISA_CHILD_ADDRESS_SUCCESS';
export const EDIT_JISA_CHILD_ADDRESS_FAILURE = 'EDIT_JISA_CHILD_ADDRESS_FAILURE';
export const TRANSFER_PRODUCT_LATER_REQUEST = 'TRANSFER_PRODUCT_LATER_REQUEST';
export const TRANSFER_PRODUCT_LATER_SUCCESS = 'TRANSFER_PRODUCT_LATER_SUCCESS';
export const TRANSFER_PRODUCT_LATER_FAILURE = 'TRANSFER_PRODUCT_LATER_FAILURE';
